import { Component } from '@angular/core';
import { MatDialogTitle, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-permission-denied-dialog',
    template: `
    <section>
      <h3 mat-dialog-title class="text-center">{{ 'permission-denied-dialog.component.non-hai-permessi-suf' | translate }}</h3>
      <mat-dialog-actions>
      <section class="d-flex justify-content-center mt-4">
        <button mat-flat-button color="accent" mat-dialog-close>{{ 'permission-denied-dialog.component.chiudi' | translate }}</button>
      </section>
      </mat-dialog-actions>
    </section>
  `,
    styles: [],
    imports: [MatDialogTitle, MatDialogActions, MatButton, MatDialogClose, TranslateModule]
})
export class PermissionDeniedDialogComponent {

  constructor() { }

}
